<template>
  <div>
    <div class="row separate-section _mb">
      <div class="col-md-6">
        <h3>Tokens de Acesso</h3>
      </div>
      <div class="col-md-6 " v-if="podeCriarToken">
        <a href="/tokens/criar" class="link-button">
          <button class="btn -right" type="button">
            + CRIAR TOKEN
          </button>
        </a>
      </div>
    </div>

    <div class="container">
      <p>
        Você pode gerar um token de acesso pessoal para cada aplicação que precisa de acesso à API do Escavador.
      </p>

      <div class="col-md-12" v-if="this.tokens.length > 0">
        <table class="Table table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Escopo</th>
              <th>Criado em (UTC)</th>
              <th>Expira em (UTC)</th>
              <th>Último uso (UTC)</th>
            </tr>
          </thead>
          <tbody v-for="token in this.tokens">
            <tr>
              <td>{{ token.name }}</td>
              <td>{{ token.escopo.join(', ') }}</td>
              <td>{{ dateFormat(token.created_at) }}</td>
              <td>{{ dateFormat(token.expires_at.date) }}</td>
              <td>{{ dateTimeFormat(token.ultimo_uso) }}</td>
              <td v-if="podeRevogarToken">
                <button
                  class="btn danger-background"
                  type="button"
                  @click="openModalRevokeToken(token)"
                  v-if="token.pode_deletar"
                >
                  <b>Revogar</b>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <token-revoke-modal
      :visible="showModalRevokeToken"
      :token="this.tokenSelecionado"
      @closeModal="closeModal">
    </token-revoke-modal>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "tokens",
  props: {
    tokens: {
      type: Array,
      default() {
        return [];
      }
    },
    podeCriarToken: {
      type: Boolean,
      default() {
        return false;
      }
    },
    podeRevogarToken: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      showModalRevokeToken: false,
      tokenSelecionado: this.tokens[0]
    };
  },
  methods: {
    openModalRevokeToken: function(token) {
      this.showModalRevokeToken = true;
      this.tokenSelecionado = token;
    },
    dateFormat: function(date) {
      return moment(date).format('DD/MM/Y');
    },
    dateTimeFormat: function(date) {
      if(date == null) {
        return 'Nunca utilizado'
      }

      return moment(date).format('DD/MM/Y HH:mm');
    },
    closeModal: function() {
      this.showModalRevokeToken = false;
    }
  }
};
</script>
<style lang="stylus">
.danger-background
  background-color #F44336
  border 1px solid #F44336

.danger-background:hover,
.danger-background:active,
.danger-background:focus {
  background-color: #B50E02
  border-color: #B50E02
}
.link-button {
  all: revert;
  font-style: border
}
</style>
